<template>
    <div>
      <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="title" :width="1300">
        <Tabs :animated="false" v-if="show">
          <TabPane label="color">
            <table class="QHtable">
              <tr>
                <th width="150px">样式项</th>
                <th style="text-align: left">示例</th>
              </tr>
              <tr>
                <td><b>六进制色值</b></td>
                <td>
                  <span style="background: #2d8cf0; color: #fff" @click="$copy('#2d8cf0')">#2d8cf0</span>
                  <span style="background: #5cadff; color: #fff" @click="$copy('#5cadff')">#5cadff</span>
                  <span style="background: #2db7f5; color: #fff" @click="$copy('#2db7f5')">#2db7f5</span>
                  <span style="background: #19be6b; color: #fff" @click="$copy('#19be6b')">#19be6b</span>
                  <span style="background: #ff9900; color: #fff" @click="$copy('#ff9900')">#ff9900</span>
                  <span style="background: #ed4014; color: #fff" @click="$copy('#ed4014')">#ed4014</span>
                  <span style="background: #17233d; color: #fff" @click="$copy('#17233d')">#17233d</span>
                  <span style="background: #515a6e; color: #fff" @click="$copy('#515a6e')">#515a6e</span>
                  <span style="background: #808695; color: #fff" @click="$copy('#808695')">#808695</span>
                  <span style="background: #c5c8ce; color: #fff" @click="$copy('#c5c8ce')">#c5c8ce</span>
                  <span style="background: #dcdee2; color: #999" @click="$copy('#dcdee2')">#dcdee2</span>
                  <span style="background: #e8eaec; color: #999" @click="$copy('#e8eaec')">#e8eaec</span>
                  <span style="background: #f8f8f9; color: #999" @click="$copy('#f8f8f9')">#f8f8f9</span>
                </td>
              </tr>
              <tr>
                <td><b>文字颜色类</b></td>
                <td>
                  <span class="CL1" @click="$copy('CL1')">CL1</span>
                  <span class="CL2" @click="$copy('CL2')">CL2</span>
                  <span class="CL3" @click="$copy('CL3')">CL3</span>
                  <span class="CL4" @click="$copy('CL4')">CL4</span>
                  <span class="CL5" @click="$copy('CL5')">CL5</span>
                  <span class="CL6" @click="$copy('CL6')">CL6</span>
                  <span class="CL7" @click="$copy('CL7')">CL7</span>
                  <span class="CL8" @click="$copy('CL8')">CL8</span>
                  <span class="CL9" @click="$copy('CL9')">CL9</span>
                  <span class="CL10" @click="$copy('CL10')">CL10</span>
                  <span class="CL11" @click="$copy('CL11')">CL11</span>
                  <span class="CL12" @click="$copy('CL12')">CL12</span>
                  <span class="CL13" @click="$copy('CL13')">CL13</span>
                </td>
              </tr>
              <tr>
                <td><b>文字强显类</b></td>
                <td>
                  <span class="hotFont1" @click="$copy('hotFont1')">hotFont1</span>
                  <span class="hotFont2" @click="$copy('hotFont2')">hotFont2</span>
                  <span class="hotFont3" @click="$copy('hotFont3')">hotFont3</span>
                  <span class="hotFont4" @click="$copy('hotFont4')">hotFont4</span>
                  <span class="hotFont5" @click="$copy('hotFont5')">hotFont5</span>
                  <span class="hotFont6" @click="$copy('hotFont6')">hotFont6</span>
                  <span class="hotFont7" @click="$copy('hotFont7')">hotFont7</span>
                  <span class="hotFont8" @click="$copy('hotFont8')">hotFont8</span>
                  <span class="hotFont9" @click="$copy('hotFont9')">hotFont9</span>
                  <span class="hotFont10" @click="$copy('hotFont10')">hotFont10</span>
                  <span class="hotFont11" @click="$copy('hotFont11')">hotFont11</span>
                  <span class="hotFont12" @click="$copy('hotFont12')">hotFont12</span>
                </td>
              </tr>
              <tr>
                <td><b>背景颜色类</b></td>
                <td>
                  <span class="BG1" @click="$copy('BG1')">BG1</span>
                  <span class="BG2" @click="$copy('BG2')">BG2</span>
                  <span class="BG3" @click="$copy('BG3')">BG3</span>
                  <span class="BG4" @click="$copy('BG4')">BG4</span>
                  <span class="BG5" @click="$copy('BG5')">BG5</span>
                  <span class="BG6" @click="$copy('BG6')">BG6</span>
                  <span class="BG7" @click="$copy('BG7')">BG7</span>
                  <span class="BG8" @click="$copy('BG8')">BG8</span>
                  <span class="BG9" @click="$copy('BG9')">BG9</span>
                  <span class="BG10" @click="$copy('BG10')">BG10</span>
                  <span class="BG11" @click="$copy('BG11')">BG11</span>
                  <span class="BG12" @click="$copy('BG12')">BG12</span>
                  <span class="BG13" @click="$copy('BG13')">BG13</span>
                </td>
              </tr>
              <tr>
                <td><b>整体文字颜色类</b></td>
                <td>
                  <table class="QHtable">
                    <tr class="TRCL1" @click="$copy('TRCL1')">
                      <td style="width: 80px">TRCL1</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td style="width: 80px"><span>复制</span></td>
                    </tr>
                    <tr class="TRCL2" @click="$copy('TRCL2')">
                      <td>TRCL2</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL3" @click="$copy('TRCL3')">
                      <td>TRCL3</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL4" @click="$copy('TRCL4')">
                      <td>TRCL4</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL5" @click="$copy('TRCL5')">
                      <td>TRCL5</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL6" @click="$copy('TRCL6')">
                      <td>TRCL6</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL7" @click="$copy('TRCL7')">
                      <td>TRCL7</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL8" @click="$copy('TRCL8')">
                      <td>TRCL8</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL9" @click="$copy('TRCL9')">
                      <td>TRCL9</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL10" @click="$copy('TRCL10')">
                      <td>TRCL10</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL11" @click="$copy('TRCL11')">
                      <td>TRCL11</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL12" @click="$copy('TRCL12')">
                      <td>TRCL12</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                    <tr class="TRCL13" @click="$copy('TRCL13')">
                      <td>TRCL13</td>
                      <td>中国新闻</td>
                      <td>美国新闻</td>
                      <td>日本信息</td>
                      <td><span>复制</span></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </TabPane>
          <TabPane label="Toast">
            <table class="QHtable">
              <tr>
                <th width="150px">提示项</th>
                <th style="text-align: left">示例</th>
                <th style="text-align: center">高级</th>
              </tr>
              <tr>
                <td><b>消息提示</b></td>
                <td>
                  <span class="BG1" @click="$msg('info', 'info')">$msg('info','info')</span>
                  <span class="BG4" @click="$msg('success', 'success')">$msg('success','success')</span>
                  <span class="BG5" @click="$msg('warning', 'warning')">$msg('warning','warning')</span>
                  <span class="BG6" @click="$msg('error', 'error')">$msg('error','error')</span>
                </td>
                <td style="text-align: center"><span class="QHset" @click="$QHopen.url('https://v4.iviewui.com/components/message', 1800)">官方用法</span></td>
              </tr>
              <tr>
                <td><b>Alert提示</b></td>
                <td>
                  <span class="BG1" @click="$alert('info', 'info', '标题')">$alert('info','info')</span>
                  <span class="BG4" @click="$alert('success', 'success')">$alert('success','success')</span>
                  <span class="BG5" @click="$alert('warning', 'warning')">$alert('warning','warning')</span>
                  <span class="BG6" @click="$alert('error', 'error')">$alert('error','error')</span>
                </td>
                <td style="text-align: center"><span class="QHset" @click="$QHopen.url('https://v4.iviewui.com/components/modal', 1800)">官方用法</span></td>
              </tr>
              <tr>
                <td><b>加载提示</b></td>
                <td>
                  <span class="BG9" @click="$loading(true, '加载中，刷新浏览器关闭')">$loading(true,'加载中，刷新浏览器关闭')</span>
                </td>
                <td style="text-align: center"><span class="QHset" @click="$QHopen.url('https://v4.iviewui.com/components/message', 1800)">官方用法</span></td>
              </tr>
              <tr>
                <td><b>页面提示</b></td>
                <td>
                  <Alert type="info" show-icon>An info prompt</Alert>
                  <Alert type="success" show-icon>A success prompt</Alert>
                  <Alert type="warning" show-icon>A warning prompt</Alert>
                  <Alert type="error" show-icon>An error prompt</Alert>
                </td>
                <td style="text-align: center"><span class="QHset" @click="$QHopen.url('https://v4.iviewui.com/components/alert', 1800)">官方用法</span></td>
              </tr>
              <tr>
                <td><b>其他提示</b></td>
                <td>
                  <span class="QHset" @click="$copy('QHset')">文字事件</span>
                  <span class="QHset" @click="$confirm({ msg: '您是否确认' })">二次确认</span>
                  <span class="QHset" @click="$openImg('/img/face.png')">图片弹窗</span>
                  <span class="QHset" @click="$copy('复制文字')">复制成功提示</span>
                  <span class="QHset" @click="$QHopen.url('https://v4.iviewui.com/components/alert', 1800)">ifram弹窗</span>
                </td>
                <td></td>
              </tr>
            </table>
          </TabPane>
          <TabPane label="验证库">
            <table class="QHtable">
              <tr>
                <th width="120px">自动验证</th>
                <th width="150px">方法</th>
                <th style="text-align: left">说明及示例</th>
                <th width="150px;text-align:center;">方法验证</th>
              </tr>
              <tr>
                <td><b>reg</b></td>
                <td style="text-align: center">全店数据</td>
                <td>112 销售，115 采购，130 平台海选订单，118 平台精选订单，121 平台普选订单</td>
                <td style="text-align: center">无</td>
              </tr>
              <tr>
                <td><b>reg</b></td>
                <td style="text-align: center">正则验证</td>
                <td>data.js-rule-type:"reg"，需要data.js-rule-rule:"自定义正则"</td>
                <td style="text-align: center">无</td>
              </tr>
              <tr>
                <td><b>Empty</b></td>
                <td style="text-align: center">不可为空</td>
                <td>data.js-rule-type:"Empty"</td>
                <td style="text-align: center">$isblank</td>
              </tr>
              <tr>
                <td><b>objEmpty</b></td>
                <td style="text-align: center">对象每个元素不可为空</td>
                <td>data.js-rule-type:"objEmpty"，多层对象数组都不为空</td>
                <td style="text-align: center">$isblank</td>
              </tr>
              <tr>
                <td><b>id</b></td>
                <td style="text-align: center">必须是正整数</td>
                <td>data.js-rule-type:"id"</td>
                <td style="text-align: center">$isId</td>
              </tr>
              <tr>
                <td><b>title</b></td>
                <td style="text-align: center">标题验证</td>
                <td>data.js-rule-type:"title"，2-100位、必须含中文</td>
                <td style="text-align: center">$isTitle</td>
              </tr>
              <tr>
                <td><b>note</b></td>
                <td style="text-align: center">备注验证</td>
                <td>data.js-rule-type:"note"，2-255位、必须含中文</td>
                <td style="text-align: center">$isNote</td>
              </tr>
              <tr>
                <td><b>idEmpty</b></td>
                <td style="text-align: center">-1||正整数</td>
                <td>data.js-rule-type:"idEmpty"，-1或大于0的正整数</td>
                <td style="text-align: center">$isIdEmpty</td>
              </tr>
              <tr>
                <td><b>tel</b></td>
                <td style="text-align: center">必须是手机号码</td>
                <td>data.js-rule-type:"tel"，必须11位手机号码</td>
                <td style="text-align: center">$isTel</td>
              </tr>
              <tr>
                <td><b>account</b></td>
                <td style="text-align: center">账号验证</td>
                <td>data.js-rule-type:"account"，6到16位+只能是数字或字母+必须含字母</td>
                <td style="text-align: center">$isAccount</td>
              </tr>
              <tr>
                <td><b>float</b></td>
                <td style="text-align: center">浮点数验证</td>
                <td>data.js-rule-type:"float"，大于0且最多保留2位数的数字</td>
                <td style="text-align: center">$isFloat</td>
              </tr>
              <tr>
                <td><b>price</b></td>
                <td style="text-align: center">金额验证</td>
                <td>data.js-rule-type:"price"，大于等于0且最多保留2位数的数字</td>
                <td style="text-align: center">$isPrice</td>
              </tr>
              <tr>
                <td><b>priceOrFushu</b></td>
                <td style="text-align: center">正负金额验证</td>
                <td>data.js-rule-type:"priceOrFushu"，正或负或0、最多保留2位(priceOrFushu)</td>
                <td style="text-align: center">$isPriceOrFushu</td>
              </tr>
              <tr>
                <td><b>MinMax</b></td>
                <td style="text-align: center">数组个数验证</td>
                <td>data.js-rule-type:"MinMax"，需要data.js-rule-rule:"1-2"，数组最少Min位、最多Max位</td>
                <td style="text-align: center">无</td>
              </tr>
              <tr>
                <td><b>MinMaxStr</b></td>
                <td style="text-align: center">逗号类个数验证</td>
                <td>data.js-rule-type:"MinMaxStr"，需要data.js-rule-rule:"1-2"，1,2,3,逗号隔开数，数组最少Min位、最多Max位</td>
                <td style="text-align: center">无</td>
              </tr>
            </table>
          </TabPane>
  
          <TabPane label="form">
            <table class="QHtable">
              <tr>
                <th width="80px">LABEL</th>
                <th width="500px">FROM</th>
                <th width="80px">类型</th>
                <th>数据</th>
              </tr>
              <tr>
                <td width="60px"><b>表单A</b></td>
                <td><Input v-model="form.A" placeholder="表单A" /></td>
                <td align="center">String</td>
                <td>{{ form.A }}</td>
              </tr>
              <tr>
                <td><b>表单B</b></td>
                <td>
                  <Input v-model="form.B" suffix="logo-usd" placeholder="表单B" />
                </td>
                <td align="center">String</td>
                <td>{{ form.B }}</td>
              </tr>
              <tr>
                <td><b>表单C</b></td>
                <td>
                  <Input v-model="form.C" placeholder="表单C" type="textarea" maxlength="100" show-word-limit />
                </td>
                <td align="center">String</td>
                <td>{{ form.C }}</td>
              </tr>
              <tr>
                <td><b>表单D</b></td>
                <td>
                  <Select v-model="form.D">
                    <Option value="">请选择</Option>
                    <Option :value="100">上架</Option>
                    <Option :value="200">下架</Option>
                  </Select>
                </td>
                <td align="center">String</td>
                <td>{{ form.D }}</td>
              </tr>
              <tr>
                <td><b>表单E</b></td>
                <td>
                  <QHcheckboxGroup v-model="form.E">
                    <Checkbox label="1">香蕉</Checkbox>
                    <Checkbox label="2">苹果</Checkbox>
                    <Checkbox label="3">西瓜</Checkbox>
                  </QHcheckboxGroup>
                </td>
                <td align="center">String</td>
                <td>{{ form.E }}</td>
              </tr>
              <tr>
                <td><b>表单F</b></td>
                <td>
                  <QHdatePicker v-model="form.F" type="daterange" placeholder="表单F" fmt="yyyy-MM-dd"> </QHdatePicker>
                </td>
                <td align="center">Array</td>
                <td>{{ JSON.stringify(form.F) }}</td>
              </tr>
              <tr>
                <td><b>表单G</b></td>
                <td>
                  <QHdatePicker v-model="form.G" type="date" placeholder="表单G" fmt="yyyy-MM-dd"> </QHdatePicker>
                </td>
                <td align="center">String</td>
                <td>{{ JSON.stringify(form.G) }}</td>
              </tr>
              <tr>
                <td><b>表单H</b></td>
                <td>
                  <QHupload v-model="form.H" :format="['png', 'jpeg', 'png', 'jpg']" accept="image/*" :max="2" :size="2048"> </QHupload>
                </td>
                <td align="center">Array</td>
                <td>{{ JSON.stringify(form.H) }}</td>
              </tr>
              <tr>
                <td><b>表单J</b></td>
                <td>
                  <Select v-model="form.J">
                    <Option value="">请选择</Option>
                    <Option :value="100">A分类</Option>
                    <Option :value="200">B分类</Option>
                  </Select>
                </td>
                <td align="center">String</td>
                <td>{{ form.J }}</td>
              </tr>
              <tr>
                <td><b>表单K</b></td>
                <td>
                  <QHupload v-model="form.K" :format="['png', 'jpeg', 'png', 'jpg']" accept="image/*" :max="2" :size="2048"> </QHupload>
                </td>
                <td align="center">Array</td>
                <td>{{ JSON.stringify(form.K) }}</td>
              </tr>
            </table>
            <div class="flex-center-y-end" style="margin-top: 10px">
              <Button type="primary" @click="saveOk()">确定</Button>
            </div>
          </TabPane>
          <TabPane label="JS数据处理库">
            <table class="QHtable">
              <tr>
                <th width="250px">方法</th>
                <th style="text-align: left">说明及示例</th>
              </tr>
              <tr>
                <td><b>$setLocalStorage(key, value)</b></td>
                <td>存入缓存数据</td>
              </tr>
              <tr>
                <td><b>$getLocalStorage(key)</b></td>
                <td>取出缓存数据</td>
              </tr>
              <tr>
                <td><b>$commaStringToArray(string)</b></td>
                <td>将逗号分隔的字符串转换为数组</td>
              </tr>
              <tr>
                <td><b>$arrayToCommaString(array)</b></td>
                <td>将数组转换为逗号分隔的字符串</td>
              </tr>
              <tr>
                <td><b>$isArr(str, value)</b></td>
                <td>str字符串是否都在value,逗号分开模式传参</td>
              </tr>
              <tr>
                <td><b>$isArrOr(str, value)</b></td>
                <td>str字符串是否有一个存在于value,逗号分开模式传参</td>
              </tr>
              <tr>
                <td><b>$getFritImg(value)</b></td>
                <td>数据库字段中取第一张图片</td>
              </tr>
              <tr>
                <td><b>$arrTocomma(items, key)</b></td>
                <td>提取数组items下的key字符并用逗号连接</td>
              </tr>
              <tr>
                <td><b>$commaToarr(str, key)</b></td>
                <td>字符串由符号分隔拆分为数组</td>
              </tr>
              <tr>
                <td><b>$copyObj(obj)</b></td>
                <td>深拷贝数据防止污染数据源</td>
              </tr>
              <tr>
                <td><b>$jsonParse(jsonString)</b></td>
                <td>解析JSON字符串</td>
              </tr>
              <tr>
                <td><b>$amount(amount)</b></td>
                <td>金额友好显示</td>
              </tr>
              <tr>
                <td><b>$trimObjectSpaces(obj)</b></td>
                <td>自动过滤掉对象所有的空格</td>
              </tr>
              <tr>
                <td><b>$trimAll(value)</b></td>
                <td>去掉字符所有空格</td>
              </tr>
              <tr>
                <td><b>$toFloor(value)</b></td>
                <td>去尾法</td>
              </tr>
              <tr>
                <td><b>$toCeil(value)</b></td>
                <td>进一法</td>
              </tr>
              <tr>
                <td><b>$toRound(value)</b></td>
                <td>四舍五入法</td>
              </tr>
              <tr>
                <td><b>$filterString(value)</b></td>
                <td>去除字符串中的指定字符</td>
              </tr>
              <tr>
                <td><b>$richtextFmt(value)</b></td>
                <td>格式化富文本编辑器中的文件路径内容</td>
              </tr>
              <tr>
                <td><b>$unique()</b></td>
                <td>唯一标识，随机数</td>
              </tr>
            </table>
          </TabPane>
        </Tabs>
      </Modal>
      <div class="QHdevBtn" v-if="Dev == 5" @click="show = true">
        <Icon type="logo-css3" />
        开发器
      </div>
      <div class="QHdevEnter" @click="enterDev()"></div>
    </div>
  </template>
  
  <script>
  import data from "./data.js";
  export default {
    name: "QHdev",
    data() {
      return {
        Dev: 5,
        form: { ...data.data },
        show: false,
        title: "开发器",
      };
    },
    mounted() {
      //检测是否是开发模式
      if (this.$getLocalStorage("Dev") == 5) {
        this.Dev = 5;
      }
    },
    methods: {
      // +----------------------------------------------------------------------
      // | Desc:进入开发模式
      // +----------------------------------------------------------------------
      enterDev() {
        this.Dev = this.Dev + 1;
        if (this.Dev == 5) {
          this.$setLocalStorage("Dev", 5);
          this.Dev = 5;
        };
        if (this.Dev > 5) {
          this.$setLocalStorage("Dev", 0);
          this.Dev = 0;
        };
      },
  
      // +----------------------------------------------------------------------
      // | Desc:确认提交
      // +----------------------------------------------------------------------
      saveOk() {
        var parameter = this.$copyObj(this.form);
        const formattedJson = JSON.stringify(parameter, null, 2);
        this.$alert(`<pre>${formattedJson}</pre>`);
      },
  
      // +----------------------------------------------------------------------
      // | Desc:清理表单
      // +----------------------------------------------------------------------
      clearFrom() {
        this.loading = false;
        this.show = false;
        this.form = { ...data.data };
        this.form.id = "";
      },
    },
  };
  </script>
  <style scoped>
  span {
    display: inline-block;
    padding: 5px;
    margin: 5px;
    cursor: pointer;
  }
  .QHdevBtn {
    background: #19be6b;
    padding: 10px;
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 10000;
    cursor: pointer;
    color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  }
  </style>
  